/**
 * Created by chenqifeng on 2016/8/31.
 */

import $ from 'jquery';
import maple from 'maple';

import {request} from '../http';
import domain from '../domain';

import mallList from '../../../../setting/mallShop.json';
import marketList from '../../../../setting/marketShop.json';

const aiTalk = function(){
    if(domain.env === 'online'){
        this.domain = "//aitalk.51tiangou.com";
    }else{
        this.domain = "//aitalk." + domain.env + ".66buy.com.cn";
    }
};

/**
 * 获取欢迎语
 * @param params
 */
aiTalk.prototype.welcome = function (params) {
    params.type = 'GET';
    this._serviceAjaxCom('/intent/welcome', params);
};

aiTalk.prototype.ask = function (params) {
    params.type = 'GET';
    this._serviceAjaxCom('/intent/ask', params);
};

aiTalk.prototype._serviceAjaxCom = function(url,params){
    params.url = this.domain + url;
    return request(params);
};
export default new aiTalk();